import { AbstractControl, ValidationErrors } from '@angular/forms';

export function passwordFormValidator(control: AbstractControl): ValidationErrors | null {
  const oldPassword = control.get('oldPassword')?.value;
  const newPassword = control.get('newPassword')?.value;
  const confirmPasswordControl = control.get('confirmPassword');
  const confirmPassword = confirmPasswordControl?.value;
  const errors: ValidationErrors = {};

  if (newPassword && confirmPassword && newPassword !== confirmPassword) {
    confirmPasswordControl?.setErrors({
      ...confirmPasswordControl.errors,
      passwordMismatch: true
    });
  } else if (confirmPasswordControl?.hasError('passwordMismatch')) {
    const confirmPasswordErrors = { ...confirmPasswordControl.errors };
    delete confirmPasswordErrors.passwordMismatch;
    confirmPasswordControl.setErrors(
      Object.keys(confirmPasswordErrors).length ? confirmPasswordErrors : null
    );
  }

  if (oldPassword && newPassword && oldPassword === newPassword) {
    errors.passwordUnchanged = true;
  }

  return Object.keys(errors).length ? errors : null;
}